import React, {useEffect} from 'react';
import ContentHeader from "../../components/Layout/Content/ContentHeader/ContentHeader";
import {UIText} from "../../enums/UIText/UIText";
import LayoutContentWrapper from "../../components/Layout/LayoutContentWrapper/LayoutContentWrapper";
import {useAppSelector} from "../../hooks/redux";
import {getLanguage} from "../../store/selectors/appSelector";
import {UXAbout} from "../../enums/UXText/UXAbout";
import styles from './About.module.css'
import image from '../../uploads/images/demoNotAllData.jpg'
import {EnumPages} from "../../enums/EnumPages";
import ImageForHorizon from "../../components/Utils/Images/ImageForHorizon/ImageForHorizon";
import {getTextByLanguage} from "../../enums/utils/getTextByLanguage";
import {EnumLanguage} from "../../enums/EnumLanguage";
import AboutText from "./AboutText/AboutText";

const About = () => {

    const language = useAppSelector(getLanguage)


    useEffect(() => {
        document.title = `${UIText.nav.aboutSystem[language]} - ${UIText.mis[EnumLanguage.ru]}`
    }, [language])
    
    return (
        <div className={styles.pageWrapper}>
            <LayoutContentWrapper>
                <ContentHeader
                    title={getTextByLanguage(UIText.nav.aboutSystem, language)}
                    description={getTextByLanguage(UXAbout.description, language)}
                    pageName={EnumPages.about}
                    editable={true}/>
            </LayoutContentWrapper>

            <ImageForHorizon blurhash={'QWKA+l9vNGoMR*oKsnfkWB_4NHNHocj?bHWpoLayR%-UNHWBo0bHj[j?oK'} src={image} alt="Айвазовский Иван. Радуга. 1873."/>
            <LayoutContentWrapper>
                <AboutText/>

            </LayoutContentWrapper>



        </div>

    );
};

export default About;